const PaymentGatewayNewPayment = () => {
  return (
    <>
      <div className="pay-gw-payment-area pt-120 pb-60">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-xl-6 col-lg-8">
              <div className="text-center">
                <h2 className="pay-gw-title pay-gw-color fs-42 ff-risk-pri">
                  Complete payment Solution For Your Business
                </h2>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-4">
              <div className="pay-gw-payment-item bg-white p-4 rounded-3 mt-20">
                <h4 className="pay-gw-color fs-20 ff-risk-pri mb-20">
                  Unlock payments
                </h4>
                <p className="mb-30">
                  Accept card and ACH for one-time or recurring payments — it’s
                  completely up to you.
                </p>
                <img
                  src="assets/img/home_34/payment-1.png"
                  alt=""
                  className="img-fluid w-100"
                />
              </div>
            </div>
            <div className="col-lg-4">
              <div className="pay-gw-payment-item pay-bg-color p-4 rounded-3 mt-20">
                <h4 className="text-white fs-20 ff-risk-pri mb-20">
                  Approve more customers
                </h4>
                <p className="text-white mb-30">
                  Accept card and ACH for one-time or recurring payments — it’s
                  completely up to you.
                </p>
                <img
                  src="assets/img/home_34/payment-2.png"
                  alt=""
                  className="img-fluid w-100"
                />
              </div>
            </div>
            <div className="col-lg-4">
              <div className="pay-gw-payment-item bg-white p-4 rounded-3 mt-20">
                <h4 className="pay-gw-color fs-20 ff-risk-pri mb-20">
                  Scale your business
                </h4>
                <p className="mb-30">
                  Accept card and ACH for one-time or recurring payments — it’s
                  completely up to you.
                </p>
                <img
                  src="assets/img/home_34/payment-3.png"
                  alt=""
                  className="img-fluid w-100"
                />
              </div>
            </div>
            <div className="col-lg-6">
              <div className="pay-gw-payment-item text-center bg-white p-4 rounded-3 mt-20">
                <img
                  src="assets/img/home_34/payment-4.png"
                  alt=""
                  className="img-fluid w-100 mb-40"
                />
                <h4 className="pay-gw-color fs-20 ff-risk-pri mt-20 mb-20">
                  Accept card payment in your online store{" "}
                </h4>
                <p className="mb-0">
                  Enhance the convenience of your online store by seamlessly
                  integrating card payments. Embrace the future of transactions.
                </p>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="pay-gw-payment-item text-center bg-white p-4 rounded-3 mt-20">
                <img
                  src="assets/img/home_34/payment-5.png"
                  alt=""
                  className="img-fluid w-100 mb-30"
                />
                <h4 className="pay-gw-color fs-20 ff-risk-pri mb-20">
                  Accept card payment in your online store{" "}
                </h4>
                <p className="mb-0">
                  Enhance the convenience of your online store by seamlessly
                  integrating card payments. Embrace the future of transactions.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PaymentGatewayNewPayment;
